const UUID_BYTE_LENGTH = 16;
const BYTE_MASK = 0xff;

const hexByte = (value: number) => value.toString(16).padStart(2, '0');

export function generateUUIDv7(): string {
  if (!globalThis.crypto?.getRandomValues) {
    throw new Error('generateUUIDv7 requires crypto.getRandomValues');
  }

  const bytes = globalThis.crypto.getRandomValues(
    new Uint8Array(UUID_BYTE_LENGTH),
  );
  const timestamp = Date.now();

  // Timestamp (48 bits). Avoid bitwise shifts for the high bytes because
  // JavaScript bitwise operators coerce numbers to 32-bit signed integers.
  bytes[0] = Math.floor(timestamp / 0x10000000000) & BYTE_MASK;
  bytes[1] = Math.floor(timestamp / 0x100000000) & BYTE_MASK;
  bytes[2] = Math.floor(timestamp / 0x1000000) & BYTE_MASK;
  bytes[3] = Math.floor(timestamp / 0x10000) & BYTE_MASK;
  bytes[4] = Math.floor(timestamp / 0x100) & BYTE_MASK;
  bytes[5] = timestamp & BYTE_MASK;

  // Version 7 (bits 4-7 of byte 6 set to 0111).
  bytes[6] = (bytes[6] & 0x0f) | 0x70;

  // Variant 1 (bits 6-7 of byte 8 set to 10).
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  return [
    Array.from(bytes.slice(0, 4), hexByte).join(''),
    Array.from(bytes.slice(4, 6), hexByte).join(''),
    Array.from(bytes.slice(6, 8), hexByte).join(''),
    Array.from(bytes.slice(8, 10), hexByte).join(''),
    Array.from(bytes.slice(10, 16), hexByte).join(''),
  ].join('-');
}
